import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  /***
   * # Check Filesize Controller.
   *
   *  ## Required API
   *  __Values__
   *  * data-check-filesize-file-input-name-value - String - name of the form field to check.
   *
   *  ## Optional API
   *  __Values__
   *  * data-check-filesize-max-file-size-in-mb-value - Number - defaults to 10 (the system wide max file size)
   *  __Targets__
   *  * data-check-filesize-target="maxFileSizeInfo" - innerText will be set to maxFileSizeInMbValue if it exists. If not, a default message will be inserted
   *
   */
  static values = {
    fileInputName: String,
    maxFileSizeInMb: { type: Number, default: 10 },
  };

  static targets = ["maxFileSizeInfo"];

  setupIsValid() {
    if (!this.hasFileInputNameValue) {
      console.error(
        "Controller setup error: data-check-filesize-file-input-name-value not found.",
      );
      return false;
    }
    const inputs = this.element.getElementsByTagName("INPUT");
    const fileInput = inputs.namedItem(this.fileInputNameValue);
    if (!fileInput || fileInput.type != "file") {
      console.error(
        `Controller setup error: No file input with name "${this.fileInputNameValue}" in `,
        inputs,
      );
      return false;
    }
    return true;
  }

  connect() {
    if (!this.setupIsValid()) {
      return;
    }

    if (this.hasMaxFileSizeInfoTarget) {
      this.maxFileSizeInfoTarget.innerText = `${this.maxFileSizeInMbValue}`;
    } else {
      const infoElement = document.createElement("p");
      infoElement.innerText = `Maximale Dateigröße: ${this.maxFileSizeInMbValue} MB`;
      this.element.insertAdjacentElement("afterbegin", infoElement);
    }

    this.upload_triggered_flag = false;
    document.addEventListener(
      "turbo:submit-start",
      this.submitStartHandler.bind(this),
    );
  }

  submitStartHandler(event) {
    // see https://turbo.hotwired.dev/reference/events
    const formSubmission = event.detail.formSubmission;
    const fileInputName = this.fileInputNameValue;
    const fileInput = formSubmission.formData.get(fileInputName);

    if (!fileInput) {
      console.error(
        `Failed to get fileInput with name ${fileInputName} in `,
        formSubmission.formData,
      );
      return;
    }
    const fileSizeInMB = fileInput.size / (1024 * 1024);
    const fileSizeHumanReadable = new Intl.NumberFormat([], {
      style: "unit",
      unit: "byte",
      notation: "compact",
      unitDisplay: "narrow",
    }).format(fileInput.size);

    if (fileSizeInMB > this.maxFileSizeInMbValue) {
      formSubmission.stop();
      alert(
        `Maximale Dateigröße: ${this.maxFileSizeInMbValue} MB. ${fileInput.name} ist ${fileSizeHumanReadable} groß.`,
      );
      return;
    }
    if (this.upload_triggered_flag) {
      return;
    }
    this.upload_triggered_flag = true;
    const formElement = formSubmission.formElement;
    const infoElement = document.createElement("p");
    infoElement.innerText = `Upload von "${fileInput.name}" (${fileSizeHumanReadable}) gestartet.`;
    formElement.insertAdjacentElement("beforeend", infoElement);
  }
}
